



import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import styles from './LocationSelector.module.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function LocationSelector({ locations, onSelect }) {
  const [selected, setSelected] = useState([]);

  const hasAll = selected.length === locations.length && locations.length > 0;

  const handleChange = (event, value) => {
    setSelected(value);
  };

  const handleSelectAll = () => {
    setSelected(hasAll ? [] : locations); // toggle all
  };

  return (
    <div className={styles.locationSelector}>
      <button
        type="button"
        onClick={handleSelectAll}
        className={styles.selectAllBtn}
        style={{ marginBottom: 12 }}
      >
        {hasAll ? "Unselect All" : "Select All"}
      </button>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={locations}
        value={selected}
        onChange={handleChange}
        getOptionLabel={option => option}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        style={{ width: '100%', background: '#fff', borderRadius: 6 }}
        ListboxProps={{
          style: {
            maxHeight: 250,
            overflowY: 'auto',
            border: '1px solid #e3e8ef',
            borderRadius: 5,
            background: '#fff',
            padding: '6px 7px',
            marginBottom: 11,
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Select Locations"
            placeholder="Type to search…"
          />
        )}
      />
      <button
        type="button"
        onClick={() => onSelect(selected)}
        disabled={selected.length === 0}
        className={styles.confirmBtn}
      >
        Confirm Selection
      </button>
    </div>
  );
}
